<template>
  <div class="login-modal" :class="{ 'login-modal--compact': !showEmailRegister }">
    <header class="login-modal__head">
      <button
        type="button"
        class="login-modal__close"
        aria-label="关闭"
        @click="handleClose"
      >
        <i class="fas fa-times"></i>
      </button>

      <div class="login-modal__promo">
        <div class="login-modal__promo-main">I'm doing, AI's doing</div>
        <div class="login-modal__promo-tags">
          <span class="login-modal__promo-tag">登录即送，AI创作大礼包</span>
          <span class="login-modal__promo-tag">对新用户和会员用户限时优惠！</span>
        </div>
      </div>
    </header>

    <div v-if="!showEmailRegister" class="login-modal__body login-modal__body--single">
      <div class="login-modal__col">
        <h2 class="login-modal__title">手机号登录</h2>
        <form class="login-modal__form" @submit.prevent="handleLogin">
          <div class="login-modal__phone-row">
            <select v-model="countryCode" class="login-modal__country">
              <option value="+86">+86</option>
            </select>
            <span class="login-modal__divider" aria-hidden="true"></span>
            <input
              v-model="loginPhone"
              type="tel"
              maxlength="11"
              class="login-modal__input login-modal__input--inline"
              placeholder="请输入手机号"
              autocomplete="tel"
            />
          </div>
          <div class="login-modal__code-row">
            <input
              v-model="loginCode"
              type="text"
              maxlength="6"
              class="login-modal__input"
              placeholder="请输入验证码"
              autocomplete="one-time-code"
            />
            <button
              type="button"
              class="plus-glass-btn plus-glass-btn--text login-modal__code-btn"
              :disabled="loginCodeCountdown > 0"
              @click="handleSendLoginCode"
            >
              {{ loginCodeCountdown > 0 ? `${loginCodeCountdown}s` : '获取验证码' }}
            </button>
          </div>
          <label class="login-modal__remember">
            <input v-model="rememberMe" type="checkbox" class="login-modal__checkbox" />
            记住登录状态
          </label>
          <button
            type="submit"
            :disabled="loginLoading"
            class="plus-glass-btn plus-glass-btn--primary plus-glass-btn--block plus-glass-btn--lg"
          >
            <span v-if="!loginLoading">登录/注册</span>
            <span v-else class="login-modal__loading"><span class="login-modal__spinner"></span> 处理中…</span>
          </button>
        </form>
        <button
          type="button"
          class="plus-glass-btn plus-glass-btn--text login-modal__link-btn"
          @click="showEmailRegister = true"
        >
          使用邮箱注册
        </button>
      </div>
    </div>

    <div v-else class="login-modal__register">
      <button
        type="button"
        class="plus-glass-btn plus-glass-btn--text login-modal__back"
        @click="showEmailRegister = false"
      >
        <i class="fas fa-arrow-left"></i>
        返回手机登录
      </button>
      <h2 class="login-modal__title">邮箱注册</h2>
      <form class="login-modal__form login-modal__form--narrow" @submit.prevent="handleRegister">
        <input
          v-model="registerUsername"
          type="text"
          required
          minlength="2"
          maxlength="20"
          class="login-modal__input"
          placeholder="用户名"
        />
        <input v-model="registerEmail" type="email" required class="login-modal__input" placeholder="邮箱" />
        <div class="login-modal__register-code">
          <input
            v-model="verificationCode"
            type="text"
            maxlength="6"
            required
            class="login-modal__input"
            placeholder="邮箱验证码"
          />
          <button
            type="button"
            class="plus-glass-btn plus-glass-btn--primary plus-glass-btn--sm login-modal__mini-btn"
            :disabled="codeCountdown > 0"
            @click="handleSendCode"
          >
            {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
          </button>
        </div>
        <input
          v-model="registerPassword"
          :type="showRegisterPassword ? 'text' : 'password'"
          required
          minlength="6"
          class="login-modal__input"
          placeholder="密码（至少6位）"
        />
        <input
          v-model="confirmPassword"
          type="password"
          required
          minlength="6"
          class="login-modal__input"
          placeholder="确认密码"
        />
        <label class="login-modal__terms">
          <input v-model="agreeTerms" type="checkbox" required class="login-modal__checkbox" />
          我同意
          <router-link to="/terms" class="login-modal__link">服务条款</router-link>
          与
          <router-link to="/privacy" class="login-modal__link">隐私政策</router-link>
        </label>
        <button
          type="submit"
          :disabled="registerLoading"
          class="plus-glass-btn plus-glass-btn--primary plus-glass-btn--block plus-glass-btn--lg"
        >
          {{ registerLoading ? '提交中…' : '创建账户' }}
        </button>
      </form>
    </div>

    <footer class="login-modal__footer">
      登录即代表同意
      <router-link to="/terms" class="login-modal__link">《用户协议》</router-link>
      和
      <router-link to="/privacy" class="login-modal__link">《隐私政策》</router-link>
      <span class="login-modal__footer-note">未注册手机号码将自动注册</span>
    </footer>
  </div>
</template>

<script>
import api from '../utils/api'
import { showSuccessToast, showErrorToast } from '../utils/toast'

export default {
  name: 'LoginFormCard',
  props: {
    overlayMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countryCode: '+86',
      showEmailRegister: false,
      loginPhone: '',
      loginCode: '',
      loginCodeCountdown: 0,
      rememberMe: true,
      loginLoading: false,
      isShowPhonePopup: false,
      dataUuid: '',
      registerUsername: '',
      registerEmail: '',
      registerPassword: '',
      confirmPassword: '',
      showRegisterPassword: false,
      verificationCode: '',
      agreeTerms: false,
      registerLoading: false,
      codeCountdown: 0
    }
  },
  mounted() {
    if (!this.overlayMode) {
      document.documentElement.classList.add('dark')
      document.body.setAttribute('data-theme', 'dark')
    }
    this.initializeRememberMe()
    this.checkExistingAuth()
  },
  beforeDestroy() {
    if (!this.overlayMode) {
      document.documentElement.classList.remove('dark')
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    finishAuthSuccess(message, delayMs = 800) {
      showSuccessToast(message)
      setTimeout(() => {
        if (this.overlayMode) {
          this.$emit('success')
          window.location.reload()
        } else {
          window.location.replace('/home')
        }
      }, delayMs)
    },
    initializeRememberMe() {
      const v = localStorage.getItem('rememberMe')
      if (v === null) {
        this.rememberMe = true
        return
      }
      this.rememberMe = v === '1' || v === 'true'
    },
    async handleLogin() {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!this.loginPhone) {
        showErrorToast('请输入手机号')
        return
      }
      if (!phoneRegex.test(this.loginPhone)) {
        showErrorToast('请输入正确的手机号')
        return
      }
      if (!this.loginCode || this.loginCode.length !== 6) {
        showErrorToast('请输入6位验证码')
        return
      }
      this.loginLoading = true
      try {
        const res = await api.post('/login/app/with-phone-code', {
          phone: this.loginPhone,
          phone_code: this.loginCode
        })
        if (res.data && (res.data.is_need_phone_number || res.data.is_need_phone)) {
          this.isShowPhonePopup = true
          this.dataUuid = res.data.data_uuid
          showErrorToast('需要绑定手机号')
        } else if (res.data && res.data.token) {
          const storage = this.rememberMe ? localStorage : sessionStorage
          storage.setItem('token', res.data.token)
          if (res.data.user) storage.setItem('user', JSON.stringify(res.data.user))
          localStorage.setItem('rememberMe', this.rememberMe ? '1' : '0')
          this.finishAuthSuccess('登录成功！即将跳转...')
        } else {
          showErrorToast(res.error || res.message || '登录失败')
        }
      } catch (error) {
        console.error('登录错误:', error)
        showErrorToast(error.response?.data?.message || error.message || '网络错误，请稍后重试')
      } finally {
        this.loginLoading = false
      }
    },
    async handleSendLoginCode() {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!this.loginPhone) {
        showErrorToast('请输入手机号')
        return
      }
      if (!phoneRegex.test(this.loginPhone)) {
        showErrorToast('请输入正确的手机号')
        return
      }
      try {
        const res = await api.post('/login/phone-code', { phone: this.loginPhone })
        if (res.success || (res.data && !res.error)) {
          showSuccessToast('验证码已发送，请查收短信')
          this.startLoginCodeCountdown(60)
        } else {
          showErrorToast(res.error || res.message || '发送失败，请稍后重试')
        }
      } catch (error) {
        console.error('发送验证码错误:', error)
        showErrorToast(error.response?.data?.message || error.message || '网络错误，无法发送验证码')
      }
    },
    startLoginCodeCountdown(seconds) {
      this.loginCodeCountdown = seconds
      const interval = setInterval(() => {
        this.loginCodeCountdown--
        if (this.loginCodeCountdown <= 0) clearInterval(interval)
      }, 1000)
    },
    async handleRegister() {
      if (this.registerPassword !== this.confirmPassword) {
        showErrorToast('两次输入的密码不一致')
        return
      }
      if (!this.verificationCode || this.verificationCode.length !== 6) {
        showErrorToast('请输入6位邮箱验证码')
        return
      }
      this.registerLoading = true
      try {
        const res = await api.post('/auth/register', {
          username: this.registerUsername,
          email: this.registerEmail,
          password: this.registerPassword,
          code: this.verificationCode
        })
        if (res.success) {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('user', JSON.stringify(res.data.user))
          this.finishAuthSuccess('注册成功！', 1000)
        } else {
          showErrorToast(res.error || '注册失败')
        }
      } catch (error) {
        console.error('注册错误:', error)
        showErrorToast('网络错误，请稍后重试')
      } finally {
        this.registerLoading = false
      }
    },
    async handleSendCode() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!this.registerEmail) {
        showErrorToast('请输入邮箱地址')
        return
      }
      if (!emailRegex.test(this.registerEmail)) {
        showErrorToast('请输入有效的邮箱地址')
        return
      }
      try {
        const res = await api.post('/auth/send-code', { email: this.registerEmail })
        if (res.success) {
          showSuccessToast('验证码已发送，请查收邮件')
          this.startCountdown(60)
        } else {
          showErrorToast(res.error || '发送失败，请稍后重试')
        }
      } catch (error) {
        console.error('发送验证码错误:', error)
        showErrorToast('网络错误，无法发送验证码')
      }
    },
    startCountdown(seconds) {
      this.codeCountdown = seconds
      const interval = setInterval(() => {
        this.codeCountdown--
        if (this.codeCountdown <= 0) clearInterval(interval)
      }, 1000)
    },
    handleQuickLogin() {
      sessionStorage.setItem('token', 'guest_token_' + Date.now())
      sessionStorage.setItem('user', JSON.stringify({ username: '访客用户' }))
      this.finishAuthSuccess('进入体验模式！', 800)
    },
    async checkExistingAuth() {
      if (this.overlayMode) return
      const token = localStorage.getItem('token') || sessionStorage.getItem('token')
      if (token) {
        try {
          const res = await api.get('/user')
          if (res && res.data) {
            const storage = localStorage.getItem('token') ? localStorage : sessionStorage
            storage.setItem('user', JSON.stringify(res.data))
            this.$router.push('/home')
          } else {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('user')
          }
        } catch (error) {
          console.error('验证失败:', error)
        }
      }
    }
  }
}
</script>

<style scoped>
.login-modal {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 720px;
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 24%),
    linear-gradient(165deg, rgba(24, 24, 32, 0.98) 0%, rgba(14, 14, 18, 0.99) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 24px 80px -12px rgba(0, 0, 0, 0.72),
    0 0 0 1px rgba(129, 140, 248, 0.06);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: rgba(255, 255, 255, 0.88);
}
.login-modal--compact {
  max-width: 440px;
}

.login-modal__head {
  position: relative;
  padding: 24px 32px 28px;
  overflow: hidden;
  background-color: #12141a;
  background-image:
    linear-gradient(180deg, rgba(14, 14, 18, 0.08) 0%, rgba(14, 14, 18, 0.52) 68%, rgba(14, 14, 18, 0.98) 100%),
    url('https://plusyifanshang.oss-cn-hangzhou.aliyuncs.com/box/img/other/pGubwLzFhDAFgwTh2CWjnCeFC3Yo5tZrPrBOJJCE.webp');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
}

.login-modal__close {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.55);
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
}
.login-modal__close:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.92);
}

.login-modal__promo {
  position: relative;
  z-index: 1;
  margin-top: 12px;
  text-align: center;
}
.login-modal__promo-main {
  display: inline-flex;
  padding: 8px 18px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}
.login-modal__promo-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
}
.login-modal__promo-tag {
  padding: 5px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.62);
}

.login-modal__body {
  display: grid;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}
.login-modal__body--single {
  display: block;
}
@media (min-width: 768px) {
  .login-modal__body:not(.login-modal__body--single) {
    grid-template-columns: 1fr 1fr;
  }
}

.login-modal__col {
  padding: 24px 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
@media (min-width: 768px) {
  .login-modal__col {
    border-bottom: 0;
  }
  .login-modal__col--right {
    border-left: 1px solid rgba(255, 255, 255, 0.06);
  }
}

.login-modal__title {
  font-size: 16px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.96);
  letter-spacing: 0.01em;
}

.login-modal__form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 20px;
}
.login-modal__form--narrow {
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

.login-modal__phone-row,
.login-modal__code-row,
.login-modal__register-code {
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;
}
.login-modal__phone-row:focus-within,
.login-modal__code-row:focus-within,
.login-modal__register-code:focus-within {
  border-color: rgba(129, 140, 248, 0.38);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.login-modal__country {
  flex-shrink: 0;
  border: 0;
  background: transparent;
  padding: 10px 8px 10px 12px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.78);
  outline: none;
  cursor: pointer;
}
.login-modal__divider {
  width: 1px;
  align-self: stretch;
  margin: 8px 0;
  background: rgba(255, 255, 255, 0.1);
}

.login-modal__input {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  padding: 10px 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.92);
  outline: none;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;
}
.login-modal__input:focus {
  border-color: rgba(129, 140, 248, 0.38);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.login-modal__input::placeholder {
  color: rgba(255, 255, 255, 0.32);
}
.login-modal__input--inline,
.login-modal__code-row .login-modal__input,
.login-modal__register-code .login-modal__input {
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.login-modal__code-row .login-modal__input {
  flex: 1;
  min-width: 0;
  padding-right: 4px;
}
.login-modal__code-btn {
  flex-shrink: 0;
  margin-right: 6px;
  padding: 6px 10px;
  font-size: 12px;
}

.login-modal__remember,
.login-modal__terms {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.48);
  cursor: pointer;
}
.login-modal__terms {
  align-items: flex-start;
}
.login-modal__checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  margin: 0;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition:
    border-color 0.18s ease,
    background 0.18s ease;
}
.login-modal__checkbox:checked {
  border-color: rgba(255, 255, 255, 0.35);
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.96) 0%, rgba(228, 228, 234, 0.92) 100%);
}
.login-modal__checkbox:checked::after {
  content: '';
  position: absolute;
  left: 3px;
  top: 0;
  width: 5px;
  height: 9px;
  border: solid #101014;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.login-modal__link-btn {
  margin-top: 14px;
  padding-left: 0;
  font-size: 12px;
}

.login-modal__qr-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.login-modal__qr-box {
  overflow: hidden;
  padding: 8px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.96);
}
.login-modal__qr-img {
  display: block;
  width: 180px;
  height: 180px;
  object-fit: contain;
}
.login-modal__qr-hint {
  margin-top: 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.42);
  text-align: center;
}

.login-modal__or {
  position: relative;
  margin: 22px 0;
  text-align: center;
}
.login-modal__or::before {
  content: '';
  position: absolute;
  inset: 50% 0 auto;
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
}
.login-modal__or span {
  position: relative;
  padding: 0 12px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.32);
  background: rgba(18, 18, 24, 0.98);
}

.login-modal__social-btn {
  border-radius: 999px;
}
.login-modal__qq-icon {
  color: #38bdf8;
  font-size: 16px;
}

.login-modal__register {
  padding: 24px 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}
.login-modal__back {
  margin-bottom: 12px;
  padding-left: 0;
  font-size: 13px;
}
.login-modal__register-code .login-modal__mini-btn {
  margin: 4px;
  flex-shrink: 0;
}

.login-modal__footer {
  padding: 14px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.02);
  text-align: center;
  font-size: 11px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.38);
}
.login-modal__footer-note {
  display: block;
}
@media (min-width: 640px) {
  .login-modal__footer-note {
    display: inline;
  }
  .login-modal__footer-note::before {
    content: ' · ';
  }
}

.login-modal__link {
  color: rgba(165, 180, 252, 0.92);
  text-decoration: none;
}
.login-modal__link:hover {
  color: rgba(199, 210, 254, 0.98);
  text-decoration: underline;
}

.login-modal__loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.login-modal__spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(16, 16, 20, 0.18);
  border-top-color: #101014;
  border-radius: 50%;
  animation: login-spin 0.75s linear infinite;
}
@keyframes login-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 767px) {
  .login-modal__head,
  .login-modal__col,
  .login-modal__register {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
